import { Navigate } from "react-router-dom";
import AuthService from "../utils/authService";
import routePaths from "./routePaths";

const PrivateRoute = ({ children }: any) => {
	if (!AuthService.isAuthenticated()) {
		return <Navigate to={routePaths.LOGIN} />;
	}
	return children;
};

export default PrivateRoute;
